import styled, { keyframes } from 'styled-components';

const animatePath = keyframes`
    from {
        stroke-dashoffset: ${props => props.pathLength};
    }

    to {
        stroke-dashoffset: 0;
    }
`;

const SVGPathBGStyled = styled.svg`
  animation: ${animatePath} 60s linear infinite;
  fill: transparent;
  stroke-dasharray: ${props => props.pathLength},
    ${props => props.pathLength / props.splits * 3}, ${props => props.pathLength};
  stroke-dashoffset: ${props => props.pathLength + props.pathLength / props.splits};
  stroke-linecap: ${props => props.theme.path.strokeLinecap};
  stroke-miterlimit: 10;
  stroke-width: calc(50px + 5vmin);
  bottom: 0;
  left: 0;
  height: 100vh;
  opacity: 0.2;
  position: absolute;
  right: 0;
  top: -50vh;
  transform: scale(3);
  width: 100vw;
  z-index: -1;

    @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
        min-height: ${props => props.theme.gameSelectorWindow.minHeight};
    }
`;

export default SVGPathBGStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/SVGPathBG/SVGPathBG.styled.js